import React, { useEffect, useState } from 'react';
import { API_URL } from '../api';

function RepoMembers({ repoId, userId }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newUsername, setNewUsername] = useState('');
  const [newRole, setNewRole] = useState('collaborator');
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState(null);

  const fetchMembers = async () => {
    try {
      const res = await fetch(`${API_URL}/api/repos/${repoId}/members?user_id=${userId}`, {
        credentials: 'include',
      });
      if (res.ok) {
        setMembers(await res.json());
      }
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line
  }, [repoId, userId]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newUsername.trim()) return;
    setAdding(true);
    setError(null);
    try {
      const res = await fetch(`${API_URL}/api/repos/${repoId}/members?user_id=${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: newUsername.trim(), role: newRole }),
        credentials: 'include',
      });
      const data = await res.json();
      if (res.ok) {
        setMembers((prev) => [...prev, data]);
        setNewUsername('');
      } else {
        setError(data.detail || 'Error adding member');
      }
    } catch {
      setError('Network error');
    } finally {
      setAdding(false);
    }
  };

  const handleRemove = async (memberId) => {
    try {
      const res = await fetch(`${API_URL}/api/repos/${repoId}/members/${memberId}?user_id=${userId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (res.ok) {
        setMembers((prev) => prev.filter((m) => m.id !== memberId));
      } else {
        const data = await res.json();
        setError(data.detail || 'Error removing member');
      }
    } catch {
      setError('Network error');
    }
  };

  if (loading) return <div className="members-loading">Loading members…</div>;

  return (
    <div className="repo-members">
      <div className="members-list">
        {members.map((m) => (
          <div key={m.id} className="member-row">
            {m.avatar_url && <img src={m.avatar_url} alt="" className="member-avatar" />}
            <span className="member-name">{m.username}</span>
            <span className="member-role">{m.role}</span>
            {m.role !== 'owner' && (
              <button
                type="button"
                className="member-remove"
                onClick={() => handleRemove(m.id)}
                title="Remove member"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
      {error && <div className="member-error">{error}</div>}
      <form onSubmit={handleAdd} className="member-add-form">
        <input
          type="text"
          value={newUsername}
          onChange={(e) => setNewUsername(e.target.value)}
          placeholder="GitHub username"
          disabled={adding}
        />
        <select value={newRole} onChange={(e) => setNewRole(e.target.value)}>
          <option value="collaborator">Collaborator</option>
          <option value="viewer">Viewer</option>
          <option value="owner">Owner</option>
        </select>
        <button type="submit" disabled={adding || !newUsername.trim()}>
          {adding ? '…' : 'Add'}
        </button>
      </form>
    </div>
  );
}

export default RepoMembers;
